<template>
<div id="app" class="site container hfeed">
  <HeadNav selectedLanguage="en" page="about-us" />

  <div id="content" class="site-content">
    <article class="about-article">
      <section class="about-content">
        <header class="about-header">
          <hh1>About Us</hh1>
        </header>

        <p>
          Welcome to <strong>GBWAOnline</strong>, your trusted source for <strong>WhatsApp Mod app insights</strong>, <strong>updates</strong>, and <strong>feature comparisons</strong>.
        </p>

        <p>
          We are a <strong>tech information platform</strong>, dedicated to helping users understand and explore modified versions of WhatsApp such as <strong>GB WhatsApp</strong>, <strong>WhatsApp Plus</strong>, <strong>FM WhatsApp</strong>, and others. Our goal is to provide <strong>accurate, up-to-date, and transparent information</strong> about these apps — including their features, download methods, differences from the official WhatsApp, and safety considerations.
        </p>

        <section class="section">
          <p>
          <strong>⚠️ Important Note:</strong>
            GBWAOnline is an <strong>independent information website</strong>.
          </p>
          <p>
            We are <strong>not affiliated with WhatsApp</strong>, <strong>Meta Inc.</strong>, or <strong>any mod app developers</strong>. All articles and guides published here are for <strong>educational and awareness purposes</strong> only. We <strong>do not host or distribute APK files</strong>.
          </p>
        </section>

        <section class="section">
          <p>
            If you have any questions, corrections, or collaboration inquiries, feel free to <strong>contact us</strong> at:
          </p>
          <p>
            <a href="mailto:support@gbwaonline.com">support@gbwaonline.com</a>
          </p>
        </section>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'AboutUs',
  components: { HeadNav },
};
</script>

<style scoped>
.about-article {
  display: block;
}

.about-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
}

.about-header {
  text-align: center;
  margin-bottom: 24px;
}

.about-content p {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
  margin: 16px 0;
}

.about-content a {
  color: #0066cc;
  text-decoration: none;
}

.about-content a:hover {
  text-decoration: underline;
}

.section {
  margin: 24px 0;
}

@media (max-width: 768px) {
  .about-content {
    padding: 16px;
    margin: 1rem auto;
  }
}
</style>

